import { Inject, Injectable } from '@angular/core';
import { Observable, Subject, fromEvent } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SESSION_CONFIG } from './session.tokens';
import { SessionConfig } from './session.types';

type CrossTabMessage =
  | { type: 'activity'; ts: number }
  | { type: 'end'; ts: number; reason: string }
  | { type: 'state'; ts: number; status: string; remainingMs: number }
  | { type: 'unauthorized'; ts: number };

@Injectable({ providedIn: 'root' })
export class CrossTabChannelService {
  private bc?: BroadcastChannel;
  private storageKey: string;
  private in$ = new Subject<CrossTabMessage>();

  readonly messages$: Observable<CrossTabMessage> = this.in$.asObservable();

  constructor(@Inject(SESSION_CONFIG) private cfg: SessionConfig) {
    this.storageKey = `__bc_${cfg.broadcastChannelName}`;

    if (typeof BroadcastChannel !== 'undefined') {
      this.bc = new BroadcastChannel(cfg.broadcastChannelName);
      this.bc.onmessage = (ev) => this.in$.next(ev.data as CrossTabMessage);
      return;
    }

    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      fromEvent<StorageEvent>(window, 'storage')
        .pipe(
          filter((event) => event.key === this.storageKey && !!event.newValue),
          map((event) => JSON.parse(event.newValue!) as CrossTabMessage)
        )
        .subscribe((msg) => this.in$.next(msg));
    }
  }

  post(message: CrossTabMessage): void {
    if (this.bc) {
      this.bc.postMessage(message);
      return;
    }

    if (typeof localStorage === 'undefined') {
      return;
    }

    try {
      localStorage.setItem(this.storageKey, JSON.stringify(message));
      localStorage.removeItem(this.storageKey);
    } catch {
      // noop
    }
  }
}
